import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiCompactListComponent } from '../../molecules/compact-list/compact-list.component';
import type { UiCompactListColumn } from '../../molecules/compact-list/compact-list.types';
import { UiFormSectionComponent } from '../../molecules/form-section/form-section.component';
import { UiInvoiceSubtotalCheckComponent } from '../../molecules/invoice-subtotal-check/invoice-subtotal-check.component';
import type { UiInvoiceSubtotalItem } from '../../molecules/invoice-subtotal-check/invoice-subtotal-check.util';

/** Listado reutilizable de comprobantes con alta y validación de subtotal. */
@Component({
  selector: 'ui-invoice-list-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiCompactListComponent,
    UiFormSectionComponent,
    UiInvoiceSubtotalCheckComponent,
  ],
  templateUrl: './invoice-list-section.component.html',
  styleUrl: './invoice-list-section.component.scss',
})
export class UiInvoiceListSectionComponent<
  T extends UiInvoiceSubtotalItem = UiInvoiceSubtotalItem,
> {
  readonly columns = input.required<readonly UiCompactListColumn<T>[]>();
  readonly rows = input.required<readonly T[]>();
  readonly expectedSubtotal = input.required<number>();
  readonly title = input('Comprobantes');
  readonly addLabel = input('Agregar');
  readonly rowKey = input('id');
  readonly rowTitleKey = input<string | null>('tipo');
  readonly emptyText = input('No se han relacionado comprobantes');

  readonly add = output<void>();
  readonly edit = output<T>();
  readonly delete = output<T>();
}
